import "./styles.css";
import "./ui/app.ts";

/* Service worker: PWA / "Add as app" support in prod only.
 * In dev (Vite on localhost, non-19001 port) the SW would cache stale bundles,
 * so we skip registration AND actively unregister any existing SW + clear its
 * caches so the live build is always served. */
const isDevServer =
  location.hostname === "localhost" && location.port !== "" && location.port !== "19001";

if ("serviceWorker" in navigator) {
  if (isDevServer) {
    void navigator.serviceWorker.getRegistrations().then((regs) => {
      for (const reg of regs) {
        void reg.unregister();
      }
    });
    if ("caches" in window) {
      void caches.keys().then((keys) => {
        for (const k of keys) {
          void caches.delete(k);
        }
      });
    }
  } else {
    // Reload once when a freshly-deployed service worker takes control, so the
    // new build's assets load without the user having to clear caches. Guarded
    // against a reload loop (controllerchange also fires on first install).
    let reloading = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading) {
        return;
      }
      reloading = true;
      window.location.reload();
    });

    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/sw.js")
        .then((registration) => {
          // A standalone PWA window can stay open for days without navigating,
          // so it never re-checks sw.js on its own. Poll for a new worker on an
          // interval and whenever the window regains focus / comes back online.
          const checkForUpdate = () => void registration.update().catch(() => {});
          setInterval(checkForUpdate, 15 * 60 * 1000);
          document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") {
              checkForUpdate();
            }
          });
          window.addEventListener("online", checkForUpdate);
        })
        .catch(() => {
          /* SW registration failed — non-critical, app works without it */
        });
    });
  }
}
